import type { BlogPostWithCategory } from "@shared/schema";

/**
 * Minutes to read a post, or null when we genuinely cannot say.
 *
 * 19 of the 113 posts carry reading_time_minutes = 0 while averaging ~1,600
 * words, so the stored value alone is not trustworthy. Falling back to the word
 * count keeps the label honest instead of printing "0 min" on a 12-minute read.
 *
 * The bare `0` those posts used to render came from `{post.reading_time_minutes
 * && <span/>}` - zero is falsy but React still prints it.
 */
export function readingMinutes(
  post: Pick<BlogPostWithCategory, "reading_time_minutes" | "word_count">,
): number | null {
  if (post.reading_time_minutes && post.reading_time_minutes > 0) {
    return post.reading_time_minutes;
  }
  if (post.word_count && post.word_count > 0) {
    return Math.max(1, Math.round(post.word_count / 200));
  }
  return null;
}
